// Подготовка данных для экспорт топа компаний в эксель
import {API_POST_GENERATE_EXCEL} from "../../constants";

export const topCompaniesReportExport = {
    data() {
        return {
            selectedTopTypeParent: {
                index: 2,
                type: 'top_earnings'
            },
            selectedTopType: 'top_earnings',
            generatedUrl: '',
            generatingUrlProcess: false
        }
    },
    methods: {
        generateTitle(selectedTopType) {
            let title = "ТОП компаний"
            switch (selectedTopType) {
                case 'top_earnings':
                    title = title + ' по выручке'
                    break;
                case 'top_debt_buyers':
                    title = title + ' по задолженности покупателей'
                    break;
                case 'top_supplies':
                    title = title + ' по поставкам'
                    break;
                case 'top_bids':
                    title = title + ' по заявкам'
                    break;
                case 'top_gross_profit':
                    title = title + ' по Gross Profit (Прибыль)'
                    break;
                case 'top_earnings_partner':
                    title = 'ТОП партнеров по выручке'
                    break;
                case 'top_debt_buyers_partner':
                    title = 'ТОП партнеров по задолженности покупателей'
                    break;
                case 'top_supplies_partner':
                    title = 'ТОП партнеров по поставкам'
                    break;
                case 'top_bids_partner':
                    title = 'ТОП партнеров по заявкам'
                    break;
                case 'top_gross_profit_partner':
                    title = 'ТОП партнеров по Gross Profit (Прибыль)'
                    break;
            }

            return title
        },
        generateSheetTitle(selectedTopType) {
            let title = ""
            switch (selectedTopType) {
                case 'top_earnings':
                case 'top_earnings_partner':
                case 'top_earnings_all':
                    title = 'Выручка'
                    break;
                case 'top_debt_buyers':
                case 'top_debt_buyers_partner':
                case 'top_debt_buyers_all':
                    title = 'Задолженность покупателей'
                    break;
                case 'top_bids':
                case 'top_bids_partner':
                case 'top_bids_all':
                    title = 'Заявки'
                    break;
                case 'top_supplies':
                case 'top_supplies_partner':
                case 'top_supplies_all':
                    title = 'Поставки'
                    break;
                case 'top_gross_profit':
                case 'top_gross_profit_partner':
                case 'top_gross_profit_all':
                    title = 'Прибыль'
                    break;
            }

            return title || 'Лист'
        },
        generateHeaders(labels, isPartner, isAll = false) {
            let headers = {}
            if (isPartner) {
                headers = {
                    "label": {
                        name: "Наименование компании",
                        format: "@"
                    },
                }
            } else {
                headers = {
                    "id": {
                        name: "ID в системе",
                        format: "@"
                    },
                    "label": {
                        name: "Наименование компании",
                        format: "@"
                    },
                    "inn": {
                        name: "ИНН",
                        format: "0"
                    },
                    "source": {
                        name: "Источник",
                        format: "@"
                    },
                    "sales_manager": {
                        name: "Sales",
                        format: "@"
                    },
                    "to_manager": {
                        name: "ТО-КАМ",
                        format: "@"
                    },
                    "teo_manager": {
                        name: "Логист",
                        format: "@"
                    },
                }
            }

            labels.forEach((label, index) => {
                headers[`yrow_${index}`] = {
                    name: label,
                    format: '@'
                }
            })

            return headers
        },
        generateItems(items, headers, selectedTopType) {
            let resultItems = []
            const managerProps = ['sales_manager', 'to_manager', 'teo_manager']

            if (selectedTopType.indexOf('_all') !== -1) {
                selectedTopType = selectedTopType.replace('_all', '')
            }
            items.forEach((item, index) => {
                let tempItem = {}
                for (var prop in headers) {
                    if (managerProps.indexOf(prop) !== -1) {
                        tempItem[prop] = (item[prop] && item[prop].name) ? item[prop].name : ''
                    } else if (item[prop]) {
                        if (prop == 'label') {
                            tempItem[prop] = item[prop].length > 40 ? (item[prop].substring(0, 40) + '...') : item[prop];
                        } else if (prop == 'source') {
                            tempItem[prop] = item[prop].name;
                        } else {
                            tempItem[prop] = item[prop]
                        }
                    } else if (item[selectedTopType] && item[selectedTopType]['data'] && item[selectedTopType]['data'][prop.replace('yrow_','')]) {
                        tempItem[`${prop}`] = item[selectedTopType]['data'][prop.replace('yrow_','')]
                    } else {
                        tempItem[prop] = managerProps.indexOf(prop) !== -1 ? '' : 0
                    }
                }
                resultItems.push(tempItem)
            })

            return resultItems
        },
        reportGenerateUrl(dataForExport) {
            this.generatingUrlProcess = true
            api.call("post", API_POST_GENERATE_EXCEL, dataForExport)
                .then(({data}) => {
                    this.generatingUrlProcess = false
                    this.generatedUrl = data
                });
        }
    }
}
